import { Sidebar } from "@/components/Sidebar";
import { UserMenu } from "@/components/UserMenu";
import { createFileRoute, Link, Outlet, redirect } from "@tanstack/react-router";
import { Settings } from "lucide-react";

export const Route = createFileRoute("/dashboard")({
  beforeLoad: ({ context, location }) => {
    // Only treat actual dev builds as development.
    const isDevelopment = import.meta.env.DEV;

    if (!context.auth?.isAuthenticated) {
      throw redirect({
        to: "/login",
        search: {
          redirect: location.href,
        },
      });
    }

    // Check authorization: require super-admin or support claim (or dev mode) -
    // matches the backend's verifyAuthToken, which authorizes both roles.
    const isAuthorized = isDevelopment || context.auth?.isSuperAdmin || context.auth?.isSupport;
    if (!isAuthorized) {
      throw redirect({
        to: "/unauthorized",
      });
    }
  },
  component: AuthLayout,
});

export function AuthLayout() {
  return (
    <div className="flex flex-col h-screen">
      <div className="flex flex-1 overflow-hidden">
        <Sidebar />
        <main className="flex-1 flex flex-col overflow-hidden">
          <header className="border-b border-border bg-background px-6 py-4 flex items-center justify-end gap-3">
            <Link
              to="/dashboard/settings"
              className="flex items-center justify-center w-9 h-9 rounded-lg text-muted-foreground hover:bg-accent hover:text-foreground transition-colors [&.active]:bg-accent [&.active]:text-foreground"
              aria-label="Settings"
            >
              <Settings className="w-4 h-4" />
            </Link>
            <UserMenu />
          </header>
          <div className="flex-1 overflow-auto">
            <div className="p-8">
              <div className="max-w-4xl mx-auto">
                <Outlet />
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
